import { useQuery } from "@tanstack/react-query";
import { getRpcUptime } from "@/lib/api";

const COLORS = { up: "bg-green-500/80 hover:bg-green-400", degraded: "bg-yellow-500/80 hover:bg-yellow-400", down: "bg-red-500/80 hover:bg-red-400", nodata: "bg-zinc-800 hover:bg-zinc-700" };
const time = (iso) => new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

const label = (b) => (b.status === "nodata" ? `${time(b.start)} · no data`
  : `${time(b.start)} · ${b.uptimePct}% up${b.avgLatencyMs != null ? ` · ${b.avgLatencyMs} ms` : ""}`);

export const UptimeBar = () => {
  const { data } = useQuery({ queryKey: ["rpcUptime"], queryFn: getRpcUptime, refetchInterval: 60000 });
  if (!data) return null;
  return (
    <div data-testid="status-uptime">
      <div className="flex items-baseline justify-between mb-2">
        <span className="text-[10px] uppercase tracking-wider text-zinc-500">RPC uptime · last 24h</span>
        <span data-testid="status-uptime-pct" className="font-mono text-sm text-green-400">
          {data.uptimePct != null ? `${data.uptimePct}%` : "collecting…"}
        </span>
      </div>
      <div className="flex gap-[3px] h-8">
        {data.buckets.map((b) => (
          <div key={b.start} data-testid="status-uptime-bucket" data-status={b.status} title={label(b)}
            className={`flex-1 rounded-sm transition-colors ${COLORS[b.status]}`} />
        ))}
      </div>
      <div className="flex justify-between text-[10px] text-zinc-600 mt-1">
        <span>24h ago</span><span>{data.samples} {data.samples === 1 ? "check" : "checks"} · every minute{data.alertsEnabled ? " · email alerts on" : ""}</span><span>now</span>
      </div>
    </div>
  );
};
